export const SUBTOTAL_LABEL = 'Subtotal (est)*';
export const SUBTOTAL_AMOUNT = '$10.00';
export const SERVICE_FEE_LABEL = 'Service fee (est)*';
export const SERVICE_FEE_AMOUNT = '$0.00';
export const TAX_LABEL = 'Tax (est)**';
export const TAX_AMOUNT = '$0.00';
export const TOTAL_LABEL = 'Total**';
export const TOTAL_AMOUNT = '$10.00';
export const SUBMIT_BUTTON_LABEL = 'Submit Order';
